"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _arkReact = require("@dateam/ark-react");
const SwitchItemContainer = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    id,
    name,
    value,
    selected,
    children,
    onClick
  } = _ref;
  const handleChange = _react.default.useCallback(event => {
    if (onClick) onClick(value, event);
  }, [value, onClick]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _arkReact.concatClassName)("switch-item", selected ? "switch-item-selected" : null)
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "radio",
    name: name,
    id: id,
    onChange: handleChange,
    checked: selected
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id
  }, children));
});
SwitchItemContainer.displayName = 'SwitchItemContainer';
process.env.NODE_ENV !== "production" ? SwitchItemContainer.propTypes = {} : void 0;
SwitchItemContainer.defaultProps = {};
var _default = exports.default = SwitchItemContainer;